import { createContext } from "react";

export const DEFAULT_UNIT_PREFERENCES = {
  // Leaching Measurements
  leaching: {
    applicationRate: {
      volume: "L",
      time: "h",
      area: "m²",
      combined: "L/h/m²"
    },
    flowRate: {
      volume: "L",
      time: "min",
      combined: "L/min"
    }
  },

  // Metal Recovery Measurements
  metalRecovery: {
    concentration: {
      mass: "g",
      volume: "L",
      combined: "g/L"
    },
    massRecovery: "kg",
    gradeOre: {
      metalMass: "g",
      oreMass: "t",
      combined: "g/t"
    }
  },

  // Physical Measurements
  physical: {
    mass: "kg",
    volume: "L",
    area: "m²",
    length: "m",
    temperature: "°C",
    pressure: "kPa",
    heapHeight: "m",
    density: {
      mass: "kg",
      volume: "m³",
      combined: "kg/m³"
    }
  },

  // Time & Rates
  timeRates: {
    time: "hours",
    recoveryRate: {
      rate: "%",
      time: "day",
      combined: "%/day"
    },
    ratioDisplay: "%",
    percentageUnit: "%"
  },

  // Operations (operational data logs)
  operations: {
    duration: "h",                    // h | min | s | days | weeks
    throughput: "t/h",                // t/h (metric) | short ton/h (TPOH) | t/day | kg/h | …
    metalProduction: "troy oz/day",   // troy oz/day | g/day | kg/day | …
  },

  // Climate Display Units
  climate: {
    temperature: "°C",       // °C | °F | K
    precipitation: "mm",     // mm | cm | in  (per day)
    windSpeed: "km/h",       // km/h | mph | m/s
    pressure: "hPa",         // hPa | kPa | psi  (also used for VPD display)
    solarRadiation: "MJ/m²", // MJ/m² | kWh/m² | W/m² | BTU/ft²  (daily total)
  }
};

export const UnitPreferencesContext = createContext({
  unitPreferences: DEFAULT_UNIT_PREFERENCES,
  updateUnitPreferences: () => {},
  saveUnitPreferences: async () => {},
  isSaving: false,
  loadError: null
});
